import React from "react";
import {
  ExtractSwarovskiPageData,
  ProductDetailPageData,
  ProductVariantDetailPageData,
  SingleProductDetailPageData,
  type BundleDetailPageData,
} from "@swo/storefront";
import { Spacer } from "../../components/_shared-components/arrangement/Space";
import { FooterComponent } from "../../components/FooterComponent/FooterComponent";
import { HeaderComponent } from "../../components/HeaderComponent/HeaderComponent";
import { useHeaderPinnedState } from "../../components/HeaderComponent/subcomponents/use-header-pinned-state";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { AutoHeaderSpacer } from "../_layout-helpers/auto-header-spacer";
import { PDPMainComponent } from "./PDPMainComponent";
import { BDPMainComponent } from "./BDPMainComponent";
import { PDPSharedLayoutComponent } from "./PDPSharedLayoutComponent";
import { getInformationSetDeliveryData } from "./PDP_SingleImageCarousel/get-information-set-delivery-data";
import { useT2 } from "../../domain/translations/translations";
import { PDPInformationSet } from "./PDP_SingleImageCarousel/information-set/PDPInformationSet";
import { CustomerServiceContactData } from "../../components/_shared-components/CustomerServiceContactData";

export type PageProps = ExtractSwarovskiPageData<SingleProductDetailPageData | ProductVariantDetailPageData>;
export type BundlePageProps = ExtractSwarovskiPageData<BundleDetailPageData>;

export const ProductDetailPageLayout: ReactTFC<
  ExtractSwarovskiPageData<ProductDetailPageData | ProductVariantDetailPageData>
> = props => {
  const [headerState, headerHooks] = useHeaderPinnedState();

  const { header, footer, ...rest } = props.data;

  const pdpT = useT2(props.data.translations.pdp);
  const deliveryT = useT2(props.data.translations.delivery);

  const informationSetDeliveryData = getInformationSetDeliveryData(deliveryT);
  const PdpInformationSet = <PDPInformationSet informationSetDeliveryData={informationSetDeliveryData} />;

  const ContactDataComponent = (
    <CustomerServiceContactData
      contactData={props.data.components.contactData}
      headline={pdpT("needHelpText")}
      chatbotEnabled={props.locale.chatbotEnabled}
      noSpacing={true}
    />
  );

  const reviewsT = useT2(props.data.translations.reviews);

  return (
    <>
      <HeaderComponent header={header} version={"normal"} headerHooks={headerHooks} />
      <AutoHeaderSpacer componentAfterHeaderTypeName={undefined} />

      <PDPSharedLayoutComponent pdpTranslations={props.data.translations.pdp}>
        {(() => {
          if (rest._tag === "bundle-product") {
            return (
              <BDPMainComponent
                data={rest}
                PdpInformationSet={PdpInformationSet}
                ContactDataComponent={ContactDataComponent}
                page={props.page}
                locale={props.locale}
                headerState={headerState}
                reviewsT={reviewsT}
              />
            );
          } else {
            return (
              <PDPMainComponent
                data={rest}
                headerState={headerState}
                locale={props.locale}
                segment={props.segment}
                page={props.page}
                PdpInformationSet={PdpInformationSet}
              >
                {ContactDataComponent}
              </PDPMainComponent>
            );
          }
        })()}
      </PDPSharedLayoutComponent>

      <Spacer size={"lg"} />
      <FooterComponent {...footer} />
    </>
  );
};
